$(document).ready(function() {
	// JavaScript/jQuery code
	var formSubmitted = false; // Flag to track form submission

	$('[data-prevent-double-click]').click(function(e) {
		if(formSubmitted) {
			e.preventDefault(); // If the form has already been submitted, prevent further submissions
			return;
		}

		// Save the ID of the clicked button
		var buttonID = $(this).attr("id");

		// Disable the button and show a spinner
		$(this).addClass('button-action-spinner');
		$(this).html('<span class="spinner"><i class="fa fa-spinner fa-spin"></i></span> Please wait');
		$(this).attr("disabled", "disabled");
		$(this).attr("aria-busy", "true");

		// Use setTimeout to create a delay before executing the rest of the code
		setTimeout(function() {
			console.log('Button with the ID ' + buttonID + ' was clicked');

			// Perform your desired action here, but do not submit the form
			// $("#this-page").submit();

			// Reset the flag after the action is completed
			formSubmitted = false;

			// After the action is completed, re-enable the button
			$('[data-prevent-double-click]').removeClass('button-action-spinner');
			$('[data-prevent-double-click]').html('Continue');
			$('[data-prevent-double-click]').removeAttr("disabled");
			$('[data-prevent-double-click]').removeAttr("aria-busy");
		}, 6000);

		// Prevent the default form submission behavior
		e.preventDefault();
		formSubmitted = true;
	});
});